module.exports = __webpack_public_path__ + "media/components/nearby-points/static/photo-6-7046ea66be9597c6099302cd4858b640.jpg";